<template>
    <div>
        <Modal
            v-model:show="show"
        >
            <div class="align-items-center">
                <div class="d-flex flex-column align-items-center">
                    <div class="send-container">
                            <div class="icon-send-background my-4">
                                <i class="fas fa-exclamation icon-send"></i>
                            </div>
                            <h2>{{ $t('emails.verify.little_missing') }}!</h2>
                            <div class="text-center">
                                <p>{{ $t('emails.verify.link_sent') }}.</p>
                            </div>
                    </div>
                </div>
                <div class="mt-3 pt-1 mb-2 px-6">
                    <BaseButton
                        outline
                        block
                        :loading="loading"
                        class="pill btn-sm"
                        :style="{
                            borderColor: color.primary,
                            color: color.primary,
                            backgroundColor: '#fff',
                        }"
                        @click="sendLink()">
                        {{ $t('emails.verify.click_another_send') }}
                    </BaseButton>
                </div>
            </div>
        </Modal>
         <VerifyEmailSending
            v-model="showSentMessage"
            @close="showSentMessage=false"
        />
    </div>
</template>

<script>

import BaseButton from '../../argon/components/BaseButton';
import VerifyEmail from '../../mixins/VerifyEmail';
import Modal from '../../argon/components/Modal';
import VerifyEmailSending from './VerifyEmailSending';

export default {
    name: 'VerifyEmailLittleMissing',
    mixins: [
        VerifyEmail,
    ],
    components: {
        BaseButton,
        Modal,
        VerifyEmailSending,
    },
    props: {
        color: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            show: false,
            showSentMessage: false,
            loading: false,
        };
    },
    watch: {
        showSentMessage(newValue) {
            if (newValue) {
                this.show = false;
            }
        },
    },
    mounted() {
        this.show = true;
    },
};
</script>

<style scoped>
.icon-send-background {
    height: 60px;
    width: 60px;
    background-color: #009be4;
    border-radius: 50px;

    display: flex;
    justify-content: center;
    align-items: center;
}
.icon-send {
    font-size: 35px;
    color: #fff;
}
.send-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.another-send {
    font-weight: 100;
    font-size: 13px;
}
.body-container {
    width: 80%;
}
</style>
